
/**
 * StepIndicatorStylesProcessor - Creates styles specific to step indicators
 */
export class StepIndicatorStylesProcessor {
  static createStepIndicatorStyles(): string {
    return `
      /* Step indicator styles */
      .onexip-calculator-container .step-item {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        position: relative !important;
        z-index: 2 !important;
        flex: 1 !important;
      }
      
      .onexip-calculator-container .step {
        width: 2.5rem !important;
        height: 2.5rem !important;
        border-radius: 9999px !important;
        background-color: #e2e8f0 !important;
        color: #64748b !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-weight: 600 !important;
        margin-bottom: 0.5rem !important;
        position: relative !important;
        z-index: 5 !important;
        cursor: pointer !important;
      }
      
      .onexip-calculator-container .step.active {
        background-color: #FB923C !important;
        color: white !important;
      }
      
      .onexip-calculator-container .step.complete {
        background-color: #FB923C !important;
        color: white !important;
      }
    `;
  }
}
